export const QUIZ_PASSING_THRESHOLD = 0.8;
